/**
 * @file: Supplier.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 供应商信息
 */
import request from '@/utils/request'

/**
 * 添加、更新供应商信息，供应商信息添加后批次信息也增加(qiuyanping)(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function supplierAdd(data) {
  return request({
    type: 'biz',
    url: 'supplier/add',
    method: 'post',
    data
  })
}

/**
 * 供应商对比分析-供应商相关统计（wrp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function supplierBigdataInfoGet(data) {
  return request({
    type: 'biz',
    url: 'supplier/bigdata/info/get',
    method: 'post',
    data
  })
}

/**
 * 供应商对比分析-供应商分析报表部分导出（wrp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function supplierBigdataListExport(data) {
  return request({
    type: 'biz',
    url: 'supplier/bigdata/list/export',
    method: 'post',
    data
  })
}

/**
 * 供应商对比分析-供应商分析报表（wrp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function supplierBigdataListGet(data) {
  return request({
    type: 'biz',
    url: 'supplier/bigdata/list/get',
    method: 'post',
    data
  })
}

/**
 * 供应商对比分析-供应商分析报表部分导出（wrp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function supplierBigdataListOptionExport(data) {
  return request({
    type: 'biz',
    url: 'supplier/bigdata/list/option/export',
    method: 'post',
    data
  })
}

/**
 * 管理端-供应商-清零异常（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function supplierClearzero(data) {
  return request({
    type: 'biz',
    url: 'supplier/clearzero',
    method: 'post',
    data
  })
}

/**
 * 删除供应商（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function supplierDelete(data) {
  return request({
    type: 'biz',
    url: 'supplier/delete',
    method: 'post',
    data
  })
}

/**
 * 根据供应商主键ID，获取供应商信息（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function supplierGet(data) {
  return request({
    type: 'biz',
    url: 'supplier/get',
    method: 'post',
    data
  })
}

/**
 * 供应商-删除证件（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function supplierIdentifyDelete(data) {
  return request({
    type: 'biz',
    url: 'supplier/identify/delete',
    method: 'post',
    data
  })
}

/**
 * 供应商-新增证件（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function supplierIdentifyInsert(data) {
  return request({
    type: 'biz',
    url: 'supplier/identify/insert',
    method: 'post',
    data
  })
}

/**
 * 供应商-更新证件（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function supplierIdentifyUpdate(data) {
  return request({
    type: 'biz',
    url: 'supplier/identify/update',
    method: 'post',
    data
  })
}

/**
 * 条件查询供应商列表（不分页）(qiuyanping)(wrp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function supplierList(data) {
  return request({
    type: 'biz',
    url: 'supplier/list',
    method: 'post',
    data
  })
}

/**
 * 根据机构ID并且可模糊匹配供应商信息(liurl)(wrp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function supplierOrgidList(data) {
  return request({
    type: 'biz',
    url: 'supplier/orgId/list',
    method: 'post',
    data
  })
}

/**
 * 管理端-供应商-分页列表查询（wzp）(wrp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function supplierPageList(data) {
  return request({
    type: 'biz',
    url: 'supplier/page/list',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Supplier.js